import React from 'react';
import './Error.css';

interface Props {
  error: string,
}

const Error: React.FC<Props> = ({ error }) => {
  const isHtmlError = typeof error === 'string' && error.trim().startsWith('<!DOCTYPE html>');

  const displayMessage = isHtmlError
    ? "An unexpected error occurred. Please try again later or contact support."
    : `Error loading details: ${error}`;

  return <p className="error">{displayMessage}</p>;
};

export default Error;